import styles from './Button.module.css';

const VARIANT_CLASS = {
  primary: styles.primary,
  secondary: styles.secondary,
  danger: styles.danger,
};

// Shared button: replaces the inline style={{...}} buttons scattered with
// slightly different padding/radius per page (Invoices.js, CreateCustomer.css,
// AddInvoice.css, EditInvoice.css all redefined near-identical variants).
export default function Button({ variant = 'primary', type = 'button', className = '', children, ...props }) {
  const variantClass = VARIANT_CLASS[variant] || VARIANT_CLASS.primary;
  return (
    <button type={type} className={`${styles.button} ${variantClass} ${className}`} {...props}>
      {children}
    </button>
  );
}
